/**
 * Post-sign-in redirect target. Only same-app paths are allowed: rejects protocol-relative
 * (`//host`), backslash tricks (`/\host`) and absolute or scheme URLs (open-redirect guard).
 */
export function safeRedirect(value: unknown): string | undefined {
  if (typeof value !== "string" || !value.startsWith("/")) return undefined;
  if (value.startsWith("//") || value.includes("\\")) return undefined;
  return value;
}
